export interface AppSpecs {
  'specs.funnel.StudioTemplatesNewMarketplaceFooter': 'true' | 'false';
  'specs.funnel.StudioTemplatesUpdatedSeoBreadcrumbs': 'true' | 'false';
  'specs.funnel.StudioTemplatesRemoveDescription': 'true' | 'false';
  'specs.funnel.PantoneWixIntegration': 'true' | 'false';
  'specs.funnel.StudioTemplatesMarketplaceGallery': 'true' | 'false';
  'specs.funnel.StudioTemplatesMegaMenuNewUi': 'true' | 'false';
  'specs.funnel.testStudioTemplatesEmptyCat': 'true' | 'false';
  'specs.funnel.StudioTemplatesTopPicsV2': 'true' | 'false';
}

export const defaultAppSpecValues: AppSpecs = {
  'specs.funnel.StudioTemplatesNewMarketplaceFooter': 'false',
  'specs.funnel.StudioTemplatesUpdatedSeoBreadcrumbs': 'false',
  'specs.funnel.StudioTemplatesRemoveDescription': 'false',
  'specs.funnel.PantoneWixIntegration': 'false',
  'specs.funnel.StudioTemplatesMarketplaceGallery': 'false',
  'specs.funnel.StudioTemplatesMegaMenuNewUi': 'true',
  'specs.funnel.testStudioTemplatesEmptyCat': 'false',
  'specs.funnel.StudioTemplatesTopPicsV2': 'false',
};
